import { render } from "./InventoryListView.vue?vue&type=template&id=31bef3fc&scoped=true"
import script from "./InventoryListView.vue?vue&type=script&lang=js"
export * from "./InventoryListView.vue?vue&type=script&lang=js"

import "./InventoryListView.vue?vue&type=style&index=0&id=31bef3fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bef3fc"]])

export default __exports__